// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__bqVNZ","disabled":"Switch_disabled__dObOK","input":"Switch_input__vIsIE","inner":"Switch_inner__hbbfE","box":"Switch_box__HBxlB"};